import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export interface SelectionOverrideState {
  show: boolean;
}

const initialState: SelectionOverrideState = {
  show: false
};

const selectionOverrideSlice = createSlice({
  name: 'selectionOverride',
  initialState,
  reducers: {
    showSelectionOverrideIndicators(state) {
      state.show = true;
    },
    hideSelectionOverrideIndicators(state) {
      state.show = false;
    },
    setShowSelectionOverrideIndicators(state, action: PayloadAction<boolean>) {
      state.show = action.payload;
    }
  }
});

export const getShowSelectionOverrideIndicators = (state: RootState) =>
  state.selectionOverride.show;

export const {
  showSelectionOverrideIndicators,
  hideSelectionOverrideIndicators,
  setShowSelectionOverrideIndicators
} = selectionOverrideSlice.actions;
export default selectionOverrideSlice.reducer;
